import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

const BootstrapTypeahead = {
  install (Vue) {
    Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
  }
}

export default BootstrapTypeahead
